// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"106":"collections","141":"intl-relative-format","255":"es6-array","490":"intl","553":"fetch","754":"url"}[chunkId] || chunkId) + "_" + {"29":"32cd","106":"3abc","141":"3f68","255":"1d9a","490":"7fd0","553":"509b","573":"f0c6","754":"831a","865":"b123","891":"d8f4"}[chunkId] + ".js";
};